import React from 'react';
import "./WhoWeAre.css"

function WhoWeAre() {
    return (
        <div className="whoweare-container">
            <h1 className="whoweare-title">Who <span className = "underlined underline-overflow">We</span> Are </h1>
            <h2 className="whoweare-text">Welcome to our car rental service page! Whether you need a car for a vacation, business trip, or any other occasion, we have a car that suits your needs. From the moment you begin your reservation process to the moment you return your car, we strive to provide you with excellent customer service, convenient rental options, and a wide selection of vehicles. Thank you for choosing our car rental services, and we look forward to serving you and making your next car rental experience one to remember.</h2>
        </div>

    )
}

export default WhoWeAre